export const faq = [
	{
		question: "How do I place an order?",
		answer: "Choose a product, add it to your cart and continue to checkout. Confirm your delivery details and selected delivery method before placing the order.",
	},
	{
		question: "Do I need an account to checkout?",
		answer: "Yes. Sign in or create an account before checkout so your order, delivery information and order history can be securely connected to you.",
	},
	{
		question: "Where can I view my orders?",
		answer: "When you are signed in, open the account menu and select My orders to see your current and previous orders.",
	},
	{
		question: "Can I cancel an order?",
		answer: "You can cancel an order from My Orders while its status is Awaiting Payment. Once processing has started, contact support for assistance.",
	},
	{
		question: "How long does delivery take?",
		answer: "Delivery time depends on your address and the method selected at checkout. The estimated timeframe is shown before you place your order.",
	},
	{
		question: "What should I do if a product is out of stock?",
		answer: "Out-of-stock products cannot be added to the cart. Check the Shop page again later or explore a similar product from the same category.",
	},
	{
		question: "How can I update my profile information?",
		answer: "Open your profile from the navbar, select Edit profile and save your updated display name, phone number, address or profile image.",
	},
	{
		question: "How do I contact Techanor Support?",
		answer: "Open the Contact tab on this page. You can call, email or complete the message form with the details of your question or order issue.",
	},
];
